import { put } from "@redux-saga/core/effects";
import axios from "axios";
import { uniqueId } from "lodash";

import { CreatePageRequestActionType, IPage } from "../types";
import { IErrorType } from "../../types/errors.d";
import { createPageByTempId } from "../actionCreators";
import { PagesService, CreatePageResponse } from "../../../services/pages";
import { createPageFailure, createPageSuccess } from "../actionCreators";

import { undo } from "../../../helpers/undoable";

export function* createPageSaga(action: CreatePageRequestActionType) {
    const tempId = uniqueId("tempId_");

    const newPage: IPage = { _id: tempId, fields: [], title: "Untitled Page" };
    try {
        yield put(createPageByTempId({ page: newPage }));

        const data: CreatePageResponse = yield PagesService.createPage({
            title: "Untitled Page",
            temp_id: newPage["_id"],
        });
        const {
            data: {
                data: { _id },
            },
        } = data;

        yield put(createPageSuccess({ tempId: newPage["_id"], _id }));
    } catch (error) {
        yield put(undo(action));
        if (axios.isAxiosError(error))
            yield put(createPageFailure({ id: newPage._id, errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(createPageFailure({ id: newPage._id, errorType: IErrorType.NATIVE, data: error }));
    }
}
